import axios from 'axios';

export const LOGIN_METHODS = {
  EMAIL: 'email',
  AUTH_TOKEN: 'token',
};

const authenticate = idToken =>
  axios.post('/sessions/sessions', { id_token: idToken });
const verifyToken = token => axios.post('/sessions/verify_token', { token });
const getAuthMethods = ({ uid }) =>
  axios.get(`/sessions/get_auth_methods?uid=${uid}`);
const getPreferredSignInMethod = ({ username, templateId }) =>
  axios.get(`/sessions/get_preferred_sign_in_method`, {
    params: {
      username,
      template_id: templateId,
    },
  });
const verifyPasswordForFirebaseToken = ({ username, password }) =>
  axios.post(`/sessions/verify_password_for_firebase_token`, {
    username,
    password,
  });
const exchangeForFirebaseToken = ({ soraban_token }) =>
  axios.post(`/sessions/exchange_for_firebase_token`, {
    soraban_token,
  });
const sendAuthLink = ({ uid, accountantId, partnerId, redirect }) =>
  axios.post(`/sessions/send_auth_link`, {
    uid,
    accountant_id: accountantId,
    partner_id: partnerId,
    redirect,
  });
const send2FALink = ({ uid }) =>
  axios.post(`/sessions/send_2fa_link`, {
    uid,
  });
const logSignIn = ({ method, ip }) =>
  axios.post(`/sessions/log_sign_in`, {
    method,
    ip,
  });
const sendSMSVerificationCode = ({ uid }) =>
  axios.post(`/sessions/send_sms_verification_code`, { uid });
const sendEmailVerificationCode = ({ uid }) =>
  axios.post(`/sessions/send_email_verification_code`, { uid });
const verifyVerificationCode = ({ uid, verificationCode }) =>
  axios.post(`/sessions/verify_verification_code`, {
    uid: uid,
    verification_code: verificationCode,
  });
const getCurrentUser = () => axios.get('/sessions/current_user');
const setDefaultCompany = companyId =>
  axios.post('/set_default_company', {
    company_id: companyId,
  });
const createUser = user => axios.post('/users', user);
const firmSelfSignUp = ({ templateHashId, ...rest }) =>
  axios.post('/resources/firm_self_sign_up', {
    template_hash_id: templateHashId,
    ...rest,
  });
const firmSelfSignUpCreateQuestionnaire = ({ templateHashId, ...rest }) =>
  axios.post('/resources/firm_self_sign_up_create_questionnaire', {
    template_hash_id: templateHashId,
    ...rest,
  });
export default {
  authenticate,
  verifyToken,
  getAuthMethods,
  getPreferredSignInMethod,
  verifyPasswordForFirebaseToken,
  exchangeForFirebaseToken,
  sendAuthLink,
  sendSMSVerificationCode,
  sendEmailVerificationCode,
  verifyVerificationCode,
  getCurrentUser,
  setDefaultCompany,
  createUser,
  firmSelfSignUp,
  firmSelfSignUpCreateQuestionnaire,
  logSignIn,
  send2FALink,
};
